import { CODE_SUCCESS } from 'constant'
import { withHandlers } from 'recompose'
import { rest } from 'services'

export default withHandlers({
  onSubmit: ({ setForgotPasswordTitleSuccess, isModal, setDescription }) => values => {
    if (isModal) {
      return rest.api
        .resetPasswordEmail(values)
        .then((
          {
            resetPasswordEmailVo: {
              status: {
                code = '',
                description
              } = {}
            } = {}
          }) => {
          code === CODE_SUCCESS && setForgotPasswordTitleSuccess && setForgotPasswordTitleSuccess()
          setDescription(description)
        })
        .catch(err => console.error(err))
    }
    return rest.api
      .resetPasswordEmail(values)
      .catch(err => console.error(err))
  }
})
